var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'container__menuoptions__background',
		{ 'container__menuoptions__background--active': _vm.isBackdropActived },
	],on:{"click":_vm.clickOptionalEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }